import React, { useEffect, useState } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const DonutLegend = (props) => {
  // let labelText = ''
  // if (props.data.text) {
  //     labelText = "</br><span className='full'>" + props.data.text + "</span>";
  // }
  const [options, setOptions] = useState({});

  useEffect(() => {

    setOptions({
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      title: {
        text: "",
        align: "left",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "{series.data.name}: <b>{point.y}</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.y} ",
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: "References",
          colorByPoint: true,
          data: [
            {
              name: "Sent",
              y:props.data[0][1],
              // sliced: true,
              // selected: true
              color: "rgb(41, 179, 175)",
            },
            {
              name: "Recieved",
              y:props.data[1][1],
              color: "rgb(229, 65, 38)",
            },
          ],
        },
      ],
    });
  }, [props]);

  return (
    <HighchartsReact
      options={options}
      highcharts={Highcharts}
      containerProps={{ className: "custom-circle-progress label-center" }}
    />
  );
};

export default DonutLegend;
